(function ($, window) {
    window.prodigyBrands = {

        init: function () {
            if ( typeof brands_settings !== "undefined" && brands_settings.brand_type === 'yes') {
              this.set_brands_swatch();
            } else {
              this.set_brands_select();
            }
        },

        set_brands_swatch: function () {
            $('.brand-swatch-js').on('click', function () {
                window.location.href = $(this).data('link');
            });
        },

        set_brands_select: function () {
            let self = this;
            let brands = ( typeof brands_settings !== "undefined" && brands_settings.widget_type === 'product') ? brands_settings.brands_list : $('div.brands-container-js').data('brands');
            if (brands !== 'undefined') {
                self.update_brand_select($('.brands-js'), brands);
                let dropdownOpened = false;
                MsDropdown.make('.brands-js', {
                    enableAutoFilter: true,
                    on: {
                        open: function () {
                            dropdownOpened = true;
                        },
                        change: function (data) {
                            if (dropdownOpened) {
                                let brand = data.option.dataset;
                                if (typeof brands_settings !== "undefined" && brands_settings.widget_type === 'basic') {
									if (data.index === -1) {
										event.preventDefault();
									} else {
										window.location.href = brand.link;
									}
                                } else if (brands_settings.widget_type === 'product') {
                                    const url = new URL(window.location.href);
                                    const params = url.searchParams;

                                    if (typeof brand.slug === "undefined") {
                                        if (params.has('brand')) {
                                            params.delete('brand');
                                            window.location.href = url.toString();
                                        }

                                        return;
                                    }

                                    const currentBrand = params.get('brand');

                                    if (currentBrand !== brand.slug) {
                                        params.set('brand', brand.slug);
                                        window.location.href = url.toString();
                                    }
                                }
                            }
                        }
                    }
                });
            }
        },

        update_brand_select: function ($select, brands) {
            $select.empty();
            let brand = prodigyGetUrlParam('brand');

            if (typeof brands_settings !== "undefined") {
                $select.append($('<option\>').text(brands_settings.brand_text));
            }

            for (let key in brands) {
                let option = $('<option>');
                option.text(brands[key].brand_name);
                for (let logo_id in brands[key].logos) {
                    if (brands[key].logos[logo_id]['logo-url'] !== undefined) {
                        option.attr('data-image', brands[key].logos[logo_id]['logo-url']);
                    }
                }

                option.attr('data-link', brands[key].brand_link);
                option.attr('data-slug', brands[key].brand_slug);

                if (typeof brand !== "undefined" && brand === brands[key].brand_slug){
                    option.attr('selected', true);
                }

                $select.append(option);
            }

        }
    };

})(jQuery, window);
jQuery(function ($) {
    window.prodigyBrands.init();
});

